export default __webpack_public_path__ + "static/media/elon-doge.a31bf702.png";